<template>
  <v-list-item class="px-0" >
    <v-list-item-icon class="px-0">
      <template v-if="isSvg">
        <v-img :src="require(`@/assets/${icon}`)" height="25" width="25" contain class="px-0" />
      </template>
      <template v-else>
        <v-icon>
          {{icon}}
        </v-icon>
      </template>

    </v-list-item-icon>

    <v-list-item-content class="px-0">
      <v-list-item-title>{{title}}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="canDisabled">
      <v-switch v-model="isDisabled"> </v-switch>
    </v-list-item-action>
  </v-list-item>
</template>
<script>
export default {
  name: 'SocialTextFieldTitle',
  methods: {
    changeValue(value) {
      this.$emit('change', value)
    }
  },
  watch: {
    isDisabled(value) {
      this.changeValue(value)
    }
  },

  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    isSvg: {
      type: Boolean,
      default: false
    },
    canDisabled: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },

  },
}
</script>